import { getImageMetaTagProps, camelizeString } from 'utils/helpers';
import { SITE_URL_HTTP } from 'config/constants';

const SET_METATAGS = 'SET_METATAGS';
const RESET_DEFAULT = 'RESET_DEFAULT';

export function setMetaTags(tags) {
    return {
        type: SET_METATAGS,
        tags
    };
}

export function resetMetaTags() {
    return {
        type: RESET_DEFAULT
    };
}

const initialState = {
    description: 'Le premier réseau social de lobbying citoyen : une plateforme unique et accessible à tous pour défendre les causes qui vous sont chères et influencez les décideurs en quelques clics.',
    name: 'Réseau social de lobbying citoyen | Factio.org',
    // facebook does not accepting https protocol ?
    image: `${SITE_URL_HTTP}factio_logo.png`,
    imageWidth: 1200,
    imageHeight: 1200
};
const NAME_APPENDIX = ' | Factio.org';
const NAME_SLICE_LENGTH = 75 - NAME_APPENDIX.length;

export default function helmet(state = initialState, action) {
    switch (action.type) {
        case SET_METATAGS: {
            const { name } = action.tags;
            let imageProps = {};

            if (action.tags.image) {
                imageProps = getImageMetaTagProps({
                    image: action.tags.image,
                    width: action.tags.imageWidth,
                    height: action.tags.imageHeight
                });

                imageProps.image = imageProps.image.replace('https://', 'http://');
            }

            return {
                ...state,
                ...action.tags,
                ...imageProps,
                name: `${camelizeString(name.slice(0, NAME_SLICE_LENGTH))}${NAME_APPENDIX}`
            };
        }

        case RESET_DEFAULT:
            return {
                ...initialState
            };

        default:
            return state;
    }
}
